<template>
  <div>
    <div class="rt-share-dialog-title">
    </div>
    <el-divider></el-divider>
    <div class="rt-share-dialog-logo-div" style="text-align: center">
      <img src="../assets/share_logo.png" class="rt-share-dialog-logo"/>
      <p class="rt-share-dialog-logo-tips">学习达人</p>
      <p class="rt-share-dialog-logo-text">跟朋友们分享一下您的学习心得，大家一起进步吧！</p>
    </div>
    <el-divider content-position="center" style="color: #999999" id="share">分享心得</el-divider>
    <div class="rt-share-dialog">
      <div class="rt-share-dialog-s">
        <el-popover
          placement="top"
          width="400"
          trigger="click" style="outline: none">
          <div class="rt-popover">
            <p class="rt-context-right-text">使用微信【扫一扫】扫描下方二维码</p>
            <div class="rt-context-right-qrcode" ref="shareCodeDiv"/>
          </div>
          <div slot="reference">
            <img src="../assets/weixin.png" class="rt-share-dialog-img"/>
            <p class="rt-share-dialog-platform" style="text-align: center">微信好友</p>
          </div>
        </el-popover>
      </div>
      <div class="rt-share-dialog-s" @click="shareToQQ">
        <img src="../assets/qq_zone.png" class="rt-share-dialog-img"/>
        <p class="rt-share-dialog-platform">QQ空间</p>
      </div>
      <div class="rt-share-dialog-s" @click="shareToQQFriend">
        <img src="../assets/share_qq_f.png" class="rt-share-dialog-img"/>
        <p class="rt-share-dialog-platform">QQ好友</p>
      </div>



      <div class="rt-share-dialog-s">
        <el-popover
          placement="top"
          width="400"
          trigger="click" style="outline: none">
          <div class="rt-popover">
            <p class="rt-context-right-text">使用钉钉【扫一扫】扫描下方二维码</p>
            <div class="rt-context-right-qrcode" ref="shareCodeDivs"/>
          </div>
          <div slot="reference">
            <img src="../assets/images/news/dingding.png" class="rt-share-dialog-img"/>
            <p class="rt-share-dialog-platform" style="text-align: center">钉钉好友</p>
          </div>
        </el-popover>
      </div>
    </div>

    <div class="rt-share-dialog">
      <div class="rt-share-dialog-s" @click="pasteUrl" v-clipboard:copy="sysAppIds">
        <img src="../assets/images/news/fuzhi.png" class="rt-share-dialog-img"/>
        <p class="rt-share-dialog-platform">复制链接</p>
      </div>

      <div class="rt-share-dialog-s">
      </div>
      <div class="rt-share-dialog-s">
      </div>
      <div class="rt-share-dialog-s">
      </div>

    </div>
  </div>
</template>

<script>

  // import wxShare from '../assets/js/wx.jsapi'
  import QRCode from 'qrcodejs2'

  export default {
    name: 'rt-share',
    data () {
      return {
        sysAppIds: ''
      }
    },
    created () {
      this.$nextTick(function () {
        this.bindQRCode(this.shareUrl);
        this.bindQRCodes(this.shareUrl);
      })
    },
    props: {
      courseName: String,
      courseSummary: String,
      shareUrl: String
    },
    methods: {
      shareToQQ () {
        let url = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(this.shareUrl) + '&sharesource=qzone&title=' + this.courseName;
        window.open(url)
      },
      pasteUrl () {
        this.sysAppIds = this.shareUrl
        this.$message({
          message: '复制成功！',
          type: 'success'
        })
      },
      shareToQQFriend () {
        let url = 'http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(this.shareUrl) + '&sharesource=qzone&title=' + this.courseName;
        window.open(url)
      },
      bindQRCode: function (url) {
        this.$refs.shareCodeDiv.innerHTML = ''
        let code = new QRCode(this.$refs.shareCodeDiv, {
          text: url,
          width: 168,
          height: 168,
          colorDark: '#333333',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.L
        })
        console.log(code)
      },
      handleOpen () {
        this.bindQRCode(this.shareUrl)
        this.bindQRCodes(this.shareUrl)
      },
      bindQRCodes: function (url) {
        this.$refs.shareCodeDivs.innerHTML = ''
        let code = new QRCode(this.$refs.shareCodeDivs, {
          text: url,
          width: 168,
          height: 168,
          colorDark: '#333333',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.L
        })
        console.log(code)
      },
    }
  }
</script>

<style scoped>

  .rt-share-dialog{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
  }
  .rt-share-dialog-s{
    flex: 1;
    -webkit-flex: 1;
    margin-top: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
  }
  .rt-share-dialog-img{
    width: 48px;
    height: 48px;
    cursor: pointer;
  }
  .rt-share-dialog-platform{
    font-size: 0.9em;
    color: #999999;
    margin-top: 10px;
  }
  .rt-share-dialog-logo{
    width: 138px;
    height: 138px;
  }
  .rt-share-dialog-title{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    margin-top: -35px;
  }
  .rt-share-dialog-title-tag{
    width: 14px;
    height: 14px;
  }
  .rt-share-dialog-title-text{
    font-size: 0.9em;
    color: #999999;
    margin: 0px;
    margin-left: 5px;
    margin-top: -2px;
  }
  .rt-share-dialog-logo-div{
    margin-bottom: 40px;
  }
  .rt-share-dialog-logo-tips{
    font-size: 1.2em;
    color: #000000;
    margin: 0px;
    margin-top: 10px;
  }
  .rt-share-dialog-logo-text{
    font-size: 0.9em;
    color: #999999;
    margin: 0px;
    margin-top: 10px;
  }

  .rt-context-right-qrcode{
    width: 168px;
    height: 168px;
    margin: 10px;
    padding-bottom: 10px;
    display:block;clear:both;
  }
  .rt-context-right-text{
    font-size: 0.9em;
    color: #999999;
    margin-top: 10px;
    margin-bottom: 5px;
    width: 100%;
    text-align: center;
  }
  .rt-popover{
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
  }
  #share::before{
    content: '';
    position: absolute;
    border-bottom: 1px solid #666666;
    /*height: 1em;*/
    /*top: -5px;*/
    left: 75px;
    /*margin-top: -1em;*/
    /*transform: rotate(45deg);*/
    width:80px;
  }
  #share::after{
    content: '';
    position: absolute;
    border-bottom: 1px solid #666666;
    /*height: 1em;*/
    /*top: -5px;*/
    left: 252px;
    /*margin-top: -1em;*/
    /*transform: rotate(45deg);*/
    width:80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RtShare.vue